import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import BeakerIcon from "@redotech/redo-icons/beaker-02.svg";
import BeakerFilledIcon from "@redotech/redo-icons/beaker-02_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useMatch } from "react-router-dom";
import { useCanAccessAbTests } from "../../../../setting/ab-tests/ab-test-access";

export const AbTestsItem = memo(function AbTestsItem() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const href = `${routes.returnsBaseUrl}/ab-tests`;
  const selected = useMatch(`${href}/*`);
  const canAccess = useCanAccessAbTests();

  if (!canAccess) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href }}
      anyChildSelected={!!selected}
      data-dd-action-name="returns_nav:ab_tests_link_click"
      FilledIcon={BeakerFilledIcon}
      friendlyName={t("A/B tests", {
        context: "returns navigation label for storefront coverage A/B tests",
      })}
      id="ab-tests"
      UnfilledIcon={BeakerIcon}
    />
  );
});
